import { memo } from 'react';
import { Flexbox } from 'react-layout-kit';
import AvatarComponent from "../../components/Avatar";
import { useStyles } from "../style";
import Loading from "./Loading";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Avatar = /*#__PURE__*/memo(function (_ref) {
  var loading = _ref.loading,
    _ref$avatar = _ref.avatar,
    avatar = _ref$avatar === void 0 ? {} : _ref$avatar,
    placement = _ref.placement,
    addon = _ref.addon,
    onClick = _ref.onClick,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 40 : _ref$size;
  var _useStyles = useStyles({
      avatarSize: size
    }),
    styles = _useStyles.styles;
  var avatarContent = /*#__PURE__*/_jsxs("div", {
    className: styles.avatarContainer,
    children: [/*#__PURE__*/_jsx(AvatarComponent, {
      avatar: avatar.avatar,
      background: avatar.backgroundColor,
      onClick: onClick,
      size: size,
      title: avatar.title
    }), /*#__PURE__*/_jsx(Loading, {
      loading: loading,
      placement: placement
    })]
  });
  if (!addon) return avatarContent;
  return /*#__PURE__*/_jsxs(Flexbox, {
    align: 'center',
    className: styles.avatarGroupContainer,
    gap: 8,
    children: [avatarContent, addon]
  });
});
export default Avatar;